export default __webpack_public_path__ + "1b71b49ce9e38bbf9f3e78295bb4738e.webp";